import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TodayPage } from '../screens/admin/TodayPage';
import { periodSearch } from '../screens/admin/period-search';

export const Route = createFileRoute('/admin/today')({
  validateSearch: z.object({ ...periodSearch }),
  component: TodayPage,
});
